import React, { useEffect, useState } from "react";
import Nav from "@/components/Nav";
import { api } from "@/lib/api";

const domains = ["All", "Launch Systems", "Earth Observation", "Space Insurance", "Policy & Regulation", "Ground Infrastructure", "Venture Capital"];

export default function Jobs() {
  const [jobs, setJobs] = useState([]);
  const [domain, setDomain] = useState("All");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      setLoading(true);
      const params = domain === "All" ? {} : { domain };
      const list = await api.jobs(params);
      setJobs(list);
      setLoading(false);
    })();
  }, [domain]);

  return (
    <div className="bg-[color:var(--f2-bg)] min-h-screen text-white">
      <Nav />
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-16">
        <div className="label-xs mb-2">§ Talent Marketplace</div>
        <h1 className="font-display uppercase tracking-tighter font-black text-4xl md:text-6xl mb-10">
          India's <span className="saffron">space</span> roles.
        </h1>

        {/* Filter */}
        <div className="flex gap-2 flex-wrap mb-8">
          {domains.map((d) => (
            <button
              key={d}
              onClick={() => setDomain(d)}
              className={`btn-crisp ${domain === d ? "btn-primary" : ""}`}
              data-testid={`filter-${d.replace(/\s+/g, "-").toLowerCase()}`}
            >
              {d}
            </button>
          ))}
        </div>

        {loading ? (
          <div className="label-xs">Loading roles…</div>
        ) : (
          <div className="hard-border">
            <div className="grid grid-cols-12 label-xs border-b border-[color:var(--f2-border)] p-4">
              <div className="col-span-4">Role</div>
              <div className="col-span-3">Company · Location</div>
              <div className="col-span-2">Domain</div>
              <div className="col-span-1">Phase</div>
              <div className="col-span-2 text-right">Salary (₹ LPA)</div>
            </div>
            {jobs.map((j, i) => (
              <div
                key={j.job_id}
                data-testid={`job-row-${j.job_id}`}
                className={`grid grid-cols-12 text-sm p-4 hover:bg-black/40 transition-colors ${i > 0 ? "border-t border-[color:var(--f2-border)]" : ""}`}
              >
                <div className="col-span-4">
                  <div className="font-display font-bold text-lg">{j.title}</div>
                  <div className="text-xs text-[color:var(--f2-muted)] mt-1">{j.tags?.join(" · ")}</div>
                </div>
                <div className="col-span-3">
                  <div>{j.company}</div>
                  <div className="text-xs text-[color:var(--f2-muted)]">{j.location}</div>
                </div>
                <div className="col-span-2 label-xs">{j.domain}</div>
                <div className="col-span-1 label-xs">{j.mission_phase}</div>
                <div className="col-span-2 text-right saffron font-mono">{j.salary_inr_lpa}</div>
              </div>
            ))}
            {jobs.length === 0 && (
              <div className="p-8 label-xs text-center">No roles for this filter.</div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
